(function () {

    // Hide the "uncategorized" product category from the WooCommerce Categories block
    let productCatTerms = document.getElementsByClassName('wc-block-product-categories-list-item__name');
    for (let i = 0; i < productCatTerms.length; i++) {
        if (productCatTerms[i].innerHTML === 'Uncategorized') {
            productCatTerms[i].parentElement.parentElement.style.display = 'none';
        }
    }

})();